/** @jsxImportSource @emotion/react */
import { Theme } from "@emotion/react";
import { Link as RouterLink } from "react-router-dom";

const cssBase = (theme: Theme) =>
  ({
    borderRadius: theme.borderRadius.round,
    color: theme.colors.fg,
    display: "inline-block",
    fontSize: theme.fontSizes.xxs,
    padding: "0.2em .8em .1em .8em",
    textAlign: "center",
    textDecoration: "none",
  } as const);

const cssFounder = (theme: Theme) => ({
  background: [theme.colors.purple, theme.gradients.tagFounder],
  "&:hover": {
    boxShadow: `0 0 0 1px ${theme.colors.purpleDark}`,
  },
});

const cssMission = (theme: Theme) => ({
  background: [theme.colors.yellow, theme.gradients.tagMission],
  "&:hover": {
    boxShadow: `0 0 0 1px ${theme.colors.greenDark}`,
  },
});

type TagLinkProps = {
  tag: string;
  variant: "founderAttributes" | "missionOrCause";
};

function TagLink({ tag, variant, ...props }: TagLinkProps) {
  const link =
    variant === "founderAttributes"
      ? `/search?founderAttributes=${encodeURIComponent(tag)}`
      : `/search?missionOrCause=${encodeURIComponent(tag)}`;
  const cssVariant = variant === "founderAttributes" ? cssFounder : cssMission;
  return (
    <RouterLink css={[cssBase, cssVariant]} to={link} {...props}>
      {tag}
    </RouterLink>
  );
}

export { TagLink };
